export const messages = {
  header: (firstName) =>
    `${
      firstName || 'User'
    } has been invited and is in your Pending Teammates list.`,
  done: 'I’m done',
  addNew: 'Add another teammate',
};
